import styled from "styled-components/macro";
import Skeleton from "react-loading-skeleton";
import classNames from "classnames";
import {DOWNVOTE, UPVOTE} from "../utils/votes";
import {BareButton} from "./button";
import Tooltip from "./tooltip";
import {themecolors} from "../utils/themecolors";

const Score = styled.span`
  ${({vote}) => vote === DOWNVOTE && `color: #9494ff;`}
  ${({vote}) => vote === UPVOTE   && `color: #ff8b60;`} 
`;

const voteIcons = {
    upInactive17: <svg width="202" height="202" viewBox="0 0 202 202" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.749 105.517L10.7489 105.517C5.88268 111.077 9.83087 119.781 17.2204 119.781H64.3353V184.9C64.3353 189.65 68.1865 193.5 72.9353 193.5H132.524C137.273 193.5 141.124 189.65 141.124 184.9V119.781H184.774C192.234 119.781 196.158 110.932 191.145 105.404C191.145 105.404 191.145 105.404 191.145 105.404L105.89 11.3738L105.89 11.3736C102.437 7.56504 96.4343 7.61668 93.0474 11.4865L10.749 105.517ZM105.84 22.6825C105.838 22.6842 105.837 22.686 105.835 22.6877L105.84 22.6826L105.84 22.6825Z" strokeWidth="17"/>
    </svg>,
    upActive17: <svg width="202" height="202" viewBox="0 0 202 202" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.749 105.517L10.7489 105.517C5.88268 111.077 9.83087 119.781 17.2204 119.781H64.3353V184.9C64.3353 189.65 68.1865 193.5 72.9353 193.5H132.524C137.273 193.5 141.124 189.65 141.124 184.9V119.781H184.774C192.234 119.781 196.158 110.932 191.145 105.404C191.145 105.404 191.145 105.404 191.145 105.404L105.89 11.3738L105.89 11.3736C102.437 7.56504 96.4343 7.61668 93.0474 11.4865L10.749 105.517ZM105.84 22.6825C105.838 22.6842 105.837 22.686 105.835 22.6877L105.84 22.6826L105.84 22.6825Z" strokeWidth="17"/>
    </svg>,
    downInactive17: <svg width="202" height="202" viewBox="0 0 202 202" xmlns="http://www.w3.org/2000/svg">
        <path d="M191.251 96.4834L191.251 96.4832C196.117 90.9231 192.169 82.2194 184.78 82.2194H137.665L137.665 17.1C137.665 12.3495 133.814 8.5 129.065 8.5H69.4765C64.7272 8.5 60.8765 12.3499 60.8765 17.1V82.2194H17.2256C9.76625 82.2194 5.84241 91.0681 10.8545 96.596C10.8546 96.5961 10.8548 96.5963 10.8549 96.5964L96.1099 190.626L96.11 190.626C99.5633 194.435 105.566 194.383 108.953 190.514L191.251 96.4834ZM96.16 179.318C96.1615 179.316 96.1631 179.314 96.1646 179.312L96.1601 179.317L96.16 179.318Z" strokeWidth="17"/>
    </svg>,
    downActive17: <svg width="202" height="202" viewBox="0 0 202 202" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M191.251 96.4834L191.251 96.4832C196.117 90.9231 192.169 82.2194 184.78 82.2194H137.665L137.665 17.1C137.665 12.3495 133.814 8.5 129.065 8.5H69.4765C64.7272 8.5 60.8765 12.3499 60.8765 17.1V82.2194H17.2256C9.76625 82.2194 5.84241 91.0681 10.8545 96.596C10.8546 96.5961 10.8548 96.5963 10.8549 96.5964L96.1099 190.626L96.11 190.626C99.5633 194.435 105.566 194.383 108.953 190.514L191.251 96.4834ZM96.16 179.318C96.1615 179.316 96.1631 179.314 96.1646 179.312L96.1601 179.317L96.16 179.318Z" strokeWidth="17"/>
    </svg>,
    upInactive12: <svg width="202" height="202" viewBox="0 0 202 202" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.749 105.517L10.7489 105.517C5.88268 111.077 9.83087 119.781 17.2204 119.781H64.3353V184.9C64.3353 189.65 68.1865 193.5 72.9353 193.5H132.524C137.273 193.5 141.124 189.65 141.124 184.9V119.781H184.774C192.234 119.781 196.158 110.932 191.145 105.404C191.145 105.404 191.145 105.404 191.145 105.404L105.89 11.3738L105.89 11.3736C102.437 7.56504 96.4343 7.61668 93.0474 11.4865L10.749 105.517ZM105.84 22.6825C105.838 22.6842 105.837 22.686 105.835 22.6877L105.84 22.6826L105.84 22.6825Z" strokeWidth="12"/>
    </svg>,
    upActive12: <svg width="192" height="192" viewBox="0 0 192 192" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.63023 102.163L7.63012 102.163C4.17853 106.107 6.979 112.281 12.2204 112.281H61.8353V179.9C61.8353 183.27 64.567 186 67.9353 186H127.524C130.892 186 133.624 183.269 133.624 179.9V112.281H179.774C185.065 112.281 187.849 106.004 184.293 102.083C184.293 102.083 184.293 102.083 184.293 102.083L99.038 8.05299L99.0379 8.05291C96.5885 5.35149 92.3311 5.38809 89.9288 8.13284C89.9287 8.13287 89.9287 8.1329 89.9287 8.13294L7.63023 102.163Z" strokeWidth="12"/>
    </svg>,
    downInactive12: <svg width="192" height="192" viewBox="0 0 192 192" xmlns="http://www.w3.org/2000/svg">
        <path d="M184.37 89.8369L184.37 89.8368C187.821 85.8929 185.021 79.7194 179.78 79.7194H130.165L130.165 12.1C130.165 8.73047 127.433 6 124.065 6H64.4765C61.1078 6 58.3765 8.73076 58.3765 12.1V79.7194H12.2256C6.93469 79.7194 4.15149 85.9958 7.70659 89.9167C7.70668 89.9168 7.70677 89.9169 7.70686 89.917L92.962 183.947L92.9621 183.947C95.4115 186.649 99.6689 186.612 102.071 183.867C102.071 183.867 102.071 183.867 102.071 183.867L184.37 89.8369Z" strokeWidth="12"/>
    </svg>,
    downActive12: <svg width="192" height="192" viewBox="0 0 192 192" xmlns="http://www.w3.org/2000/svg">
        <path d="M184.37 89.8369L184.37 89.8368C187.821 85.8929 185.021 79.7194 179.78 79.7194H130.165L130.165 12.1C130.165 8.73047 127.433 6 124.065 6H64.4765C61.1078 6 58.3765 8.73076 58.3765 12.1V79.7194H12.2256C6.93469 79.7194 4.15149 85.9958 7.70659 89.9167C7.70668 89.9168 7.70677 89.9169 7.70686 89.917L92.962 183.947L92.9621 183.947C95.4115 186.649 99.6689 186.612 102.071 183.867C102.071 183.867 102.071 183.867 102.071 183.867L184.37 89.8369Z" strokeWidth="12"/>
    </svg>,
}

export const PostVote = styled(({className, onVote, vote, score, up, down, animate}) => (
    <div className={`${className} vote`}>
        <BareButton
            className={classNames("up", "vote-delta", {animate: animate === UPVOTE}, {active: vote === UPVOTE})}
            onClick={() => onVote(UPVOTE)}>
            {vote === UPVOTE ? voteIcons.upActive17 : voteIcons.upInactive17}
        </BareButton>
        <Tooltip content={`+${up} / -${down}`}>
            <Score className='count' vote={vote}>{typeof score === 'number' ? score : <Skeleton />}</Score>
        </Tooltip>
        <BareButton
            className={classNames("down", "vote-delta", {animate: animate === DOWNVOTE}, {active: vote === DOWNVOTE})}
            onClick={() => onVote(DOWNVOTE)}>
            {vote === DOWNVOTE ? voteIcons.downActive17 : voteIcons.downInactive17}
        </BareButton>
    </div>
))`
  align-items: center;
  display:flex;
  flex-direction: column;
  min-width: 35px;
  margin: 0 12px 0 10px;
  font-size: 14px;
  svg {
    width: 16px;
    height: 16px;
    vertical-align: middle;
  }
  .down svg {
    fill: ${({vote}) => vote === DOWNVOTE ? "#9494ff" : "transparent"};
    stroke: ${({ vote }) => (vote === DOWNVOTE ? "#9494ff" :
            ({theme, condensed}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text:
                    (condensed ? themecolors.light_medium_impact_text : themecolors.light_high_impact_text))};
  }

  .up svg {
    fill: ${({vote}) => vote === UPVOTE ? "#ff8b60" : "transparent"};
    stroke: ${({ vote }) => (vote === UPVOTE ? "#ff8b60" :
            ({theme, condensed}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text :
                    (condensed ? themecolors.light_medium_impact_text : themecolors.light_high_impact_text))};
  }
  
  ${BareButton}.up:focus:after {
    position: absolute;
    width: 32px;
    height: 32px;
    opacity: 1;
    z-index: 2;
    content: ' ';
    background: #ff8b60;
    border-radius: 50%;
    -webkit-animation: vote .25s ease-out forwards;
    margin-top: -24px;
    margin-left: -16px;
  }
  .vote-delta {
    padding: 2px 6px;
  }
`;

export const CommentVote = styled(({className, vote, onVote}) => (
    <div className={className}>
        <BareButton className={"up"} onClick={() => onVote(UPVOTE)}>
            {vote === UPVOTE ? voteIcons.upActive17 : voteIcons.upInactive17}
        </BareButton>
        <BareButton className={"down"} onClick={() => onVote(DOWNVOTE)}>
            {vote === DOWNVOTE ? voteIcons.downActive17 : voteIcons.downInactive17}
        </BareButton>
    </div>
))`
  align-items: center;
  display: flex;
  flex-direction: column;
  min-width: 35px;
  margin: 0 4px 0 4px;
  font-size: 18px;
  padding-top: 8px;
  svg {
    width: 14px;
    height: 14px;
    vertical-align: middle;
  }
  .down svg {
    fill: ${({vote}) => vote === DOWNVOTE ? "#9494ff" : "transparent"};
    stroke: ${({ vote }) => (vote === DOWNVOTE ? "#9494ff" :
            ({theme, condensed}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text:
                    (condensed ? themecolors.light_medium_impact_text : themecolors.light_high_impact_text))};
  }

  .up svg {
    fill: ${({vote}) => vote === UPVOTE ? "#ff8b60" : "transparent"};
    stroke: ${({ vote }) => (vote === UPVOTE ? "#ff8b60" :
            ({theme, condensed}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text :
                    (condensed ? themecolors.light_medium_impact_text : themecolors.light_high_impact_text))};
    margin-bottom: 8px;
  }
  ${BareButton}.up:focus:after {
    position: absolute;
    width: 32px;
    height: 32px;
    opacity: 1;
    z-index: 2;
    content: ' ';
    background: #ff8b60;
    border-radius: 50%;
    -webkit-animation: vote .25s ease-out forwards;
    margin-top: -32px;
    margin-left: -16px;
  }
  .up, .down {
    padding: 0 6px;
  }
`;
